import I18n from "i18n-js";

I18n.translations = { en: window.translations };
I18n.locale = "en";
export default I18n;
